import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Eye, EyeOff } from "mdi-material-ui";
import { useState } from "react";
export function PasswordField(props) {
    const [showPassword, setShowPassword] = useState(false);
    return (_jsx(TextField, { type: showPassword ? "text" : "password", name: "password", fullWidth: true, inputProps: {
            autoCapitalize: "none",
        }, InputProps: {
            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { tabIndex: -1, "aria-label": "toggle password visibility", onClick: () => setShowPassword(!showPassword), children: showPassword ? _jsx(Eye, {}) : _jsx(EyeOff, {}) }) })),
        }, ...props }));
}
//# sourceMappingURL=PasswordField.js.map